export default __webpack_public_path__ + "static/8-227ffd837e4fd7bb78761c8dfa84fce9.svg";